<div class="row">
  <form [formGroup]="form">
    <div class="text-center mt-2">
      <p><span>Nom du bien :</span>{{propertyName}}</p>
      <p><span>Adresse :</span>{{propertyAddress}}</p>
      <p><span>Parcelle principale :</span>{{propertyLandRegistry}}</p>
      <p *ngIf="propertyOtherLandRegistries?.length>0" class="registries"><span>Autre(s) parcelle(s)
          :</span>{{propertyOtherLandRegistriesDisplay}}
      </p>
      <p><span>Bien en coproriété :</span>{{propertyCondo}}</p>
      <p *ngIf="propertyOnSale"><span>Mis en vente :</span> le {{propertySaleDate}} au prix de {{propertySalePrice |
        currency:
        'EUR':'symbol':'1.0' }}</p>
    </div>
    <div class="text-center mt-4">
      <div>Valider la création du bien ?</div>
      <mat-radio-group [formControl]="form_validateCreate">
        <mat-radio-button [value]="true">Oui</mat-radio-button>
        <mat-radio-button [value]="false">Non</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="!form_validateCreate.value">Cliquez sur oui pour pouvoir valider</mat-error>
      <!--<div>Souhaitez-vous certifier le bien ?</div>
      <mat-radio-group [formControl]="form_certify">
        <mat-radio-button [value]="true">Oui</mat-radio-button>
        <mat-radio-button [value]="false">Non</mat-radio-button>
      </mat-radio-group>
      <div class="d-flex justify-content-center">
        <div class="certif-comment">La certification vous permettra de partager le bien et de récupérer
          automatiquement les données publiques.</div>
      </div>-->
    </div>
  </form>
</div>